import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Form,
  Table,
  Input,
  Button,
  Select,
  Modal,
  Calendar,
  Radio,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import Loader from "../util/Loader";
import "./Main.css";
import LoginCheck from "../util/LoginCheck";
import DecodeData from "../util/DecodeData";
import LoginFail from "../util/LoginFail";
import { useSelector, useDispatch } from "react-redux";
import { confirmAlert } from "react-confirm-alert";
import moment from "moment";
import "moment/locale/ko";
import setup from "../setup";
import GetApiHost from "../util/GetApiHost";
import locale from "antd/es/calendar/locale/ko_KR";
import pr from "../util/pr";

// CSS
const calendarContainerStyle = {
  display: "flex",
};

const calendarStyle = {
  width: 300,
};

const inputStyle = {
  width: 110,
  marginLeft: 5,
};

const labelStyle = {
  paddingLeft: 30,
  paddingRight: 10,
};
// paddingLeft:30, paddingRight:10, fontWeight:"bold"

const layout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 12,
  },
};

const tailLayout = {
  wrapperCol: {
    offset: 4,
    span: 16,
  },
};

let storage = {
  tcd: "",
  cid: "",
  name: "",
  date: "",
};
const { Option } = Select;

function ReservationOnPopup() {
  const [hourConfig, setHourConfig] = useState([]);
  const [endHourConfig, setEndHourConfig] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const data = useSelector((state) => state.data);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  moment.locale("ko");

  const columns = [
    {
      title: "구분",
      dataIndex: "pt_type",
      key: "pt_type",
    },
    {
      title: "시작",
      dataIndex: "start_time",
      key: "start_time",
    },
    {
      title: "종료",
      dataIndex: "end_time",
      key: "end_time",
    },
    {
      title: "인원",
      dataIndex: "max_count",
      key: "max_count",
      align: "center",
    },
    {
      title: "삭제",
      dataIndex: "seq",
      key: "seq",
      render: (seq) => {
        return (
          <div>
            <DeleteOutlined
              onClick={() => {
                handleDelete(seq);
              }}
            />
          </div>
        );
      },
      width: 80,
    },
  ];

  function getQuery() {
    var url = document.location.href;
    var qs = url.substring(url.indexOf("?") + 1).split("&");
    for (var i = 0, result = {}; i < qs.length; i++) {
      qs[i] = qs[i].split("=");
      result[qs[i][0]] = decodeURIComponent(qs[i][1]);
    }
    return result;
  }

  function handleDelete(seq) {
    confirmAlert({
      title: "삭제 확인",
      message: storage.name + "강사님의 근무정보를 삭제하시겠습니까?",
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteOn(seq),
        },
        {
          label: "No",
        },
      ],
    });
  }

  const onChangeStartTime = (e) => {
    let val = hourConfig.find((el) => el.seq === e).value;
    form.setFieldsValue({
      start_time: val,
    });
  };

  const onChangeEndTime = (e) => {
    let val = endHourConfig.find((el) => el.seq === e).value;
    form.setFieldsValue({
      end_time: val,
    });
  };
  const onFinish = async (values) => {
    let {
      start_time_cd,
      end_time_cd,
      start_time,
      end_time,
      pt_type,
      max_count,
    } = values;

    if (pt_type === undefined) {
      Modal.error({ title: "오류", content: "구분을 선택하세요." });
      return;
    }

    if (max_count == 0 || isNaN(max_count)) {
      Modal.error({ title: "오류", content: "인원을 입력하세요." });
      return;
    }

    if (start_time_cd === undefined) {
      Modal.error({ title: "오류", content: "시작시간을 입력하세요." });
      return;
    }

    if (end_time_cd === undefined) {
      Modal.error({ title: "오류", content: "종료시간을 입력하세요." });
      return;
    }

    if (parseInt(start_time_cd) >= parseInt(end_time_cd)) {
      alert('*'+start_time_cd+'*');
      alert('*'+end_time_cd+'*');
      
      Modal.error({ title: "오류", content: "종료시간은 시작 시간보다 크게 설정하세요." });
      return;
    }    

    // 등록
    const host = GetApiHost();
    const result = await axios.post(host + "/gympass_admin/add_teacher_on", {
      cid: storage.cid,
      tcd: storage.tcd,
      start_time_cd: start_time_cd,
      end_time_cd: end_time_cd,
      start_time: start_time,
      end_time: end_time,
      on_date: storage.date,
      pt_type: pt_type,
      max_count: max_count,
    });
    if (result.data.ret == "Y") {
      alert("등록 되었습니다");
      window.location.reload();
      window.opener.location.reload();
    } else {
      alert(result.data.msg);
    }

  };

  const deleteOn = (seq) => {
    (async function () {
      const host = GetApiHost();
      const result = await axios.post(
        host + "/gympass_admin/delete_teacher_on",
        {
          seq: seq,
        }
      );
      if (result.data.ret == "Y") {
        alert("삭제되었습니다");
        window.location.reload();
      } else {
        alert(result.data.msg);
      }
    })();
  };

  const getHourConfig = () => {
    (async function () {
      const host = GetApiHost();
      const result = await axios.post(
        host + "/gympass_admin/get_hour_config",
        {}
      );
      setHourConfig(result.data.rows); // 시작시간

      let arr = result.data.rows;
      // arr = arr.concat({
      //   seq: "34",
      //   value: "22:30",
      // });
      arr = arr.concat({
        seq: "35",
        value: "23:00",
      });
      setEndHourConfig(arr); // 종료시간
    })();
  };

  function getDataSource() {
    (async function () {
      const host = GetApiHost();
      const result = await axios.post(host + "/gympass_admin/get_teacher_on", {
        tcd: storage.tcd,
        date: storage.date,
      });
      setDataSource(result.data.rows);
    })();
  }

  async function main() {
    let query = getQuery();
    storage.tcd = query.tcd;
    storage.cid = query.cid;
    storage.name = query.name;
    storage.date = query.date;
    const result = await LoginCheck(data.url);
    if (result === "Y") {
      const decodeResult = await DecodeData(data.url);
      dispatch({ type: "SET", name: "CID", value: decodeResult.cid });
      dispatch({ type: "SET", name: "LEVEL", value: decodeResult.level });
      getDataSource();
      getHourConfig();
      setInterval(() => {
        setIsLoading(false);
      }, 100);
    } else {
      LoginFail();
    }
  }

  useEffect(() => {
    main();
  }, []);

  if (isLoading) return <Loader />;

  // 달력 날짜선택
  const onSelectCalendar = (value) => {
    const date = moment(value).format("YYYY-MM-DD");
    window.location.href =
      "/reservationOnPopup?tcd=" +
      storage.tcd +
      "&cid=" +
      storage.cid +
      "&name=" +
      storage.name +
      "&date=" +
      date;
  };

  // 주간일정 복사
  const onCopyButton = async() => {
    const {tcd, cid, date} = storage;
    const host = GetApiHost();
    
    const result = await axios.post(host+'/gympass_admin/copy_schedule',{tcd:tcd, cid:cid, date:date});
    Modal.success({ title: "성공", content: "선택한 날이 포함된 주의 일정이 다음 주로 복사되었습니다." });
  }

  return (
    <main className="popup-container">
      <div className="content-inner">
        <h3>
          근무시간 등록 :{" "}
          {moment(storage.date).format("YYYY년 MM월 DD일 (ddd)")} -{" "}
          {storage.name} 강사
        </h3>
        <div>
          <div className="content-body">
            <div className="add-body">
              <div style={calendarContainerStyle}>
                <div style={calendarStyle}>
                  <Calendar
                    fullscreen={false}
                    locale={locale}
                    onSelect={onSelectCalendar}
                    defaultValue={moment(storage.date)}
                  />
                </div>

                <Form {...layout} form={form} onFinish={onFinish}>
                  {/* <Form.Item name="pt_type" label="구분" style={label}>
                    <Select style={ inputStyle }>
                      <Option value="">선택</Option>
                      <Option value="GX">GX</Option>
                      <Option value="PT">PT</Option>
                    </Select>
                  </Form.Item> */}

                  <Form.Item
                    name="pt_type"
                    label="구분"
                    style={{ marginLeft: 30 }}
                  >
                    <Radio.Group style={{ marginLeft: 5, display: "flex" }}>
                      <Radio value="GX">그룹PT</Radio>
                      <Radio value="PT">PT</Radio>
                    </Radio.Group>
                  </Form.Item>

                  <Form.Item
                    name="max_count"
                    label="인원"
                    initialValue="0"
                    style={{ marginLeft: 30 }}
                  >
                    <Input style={{ width: 70, marginLeft: 5 }}></Input>
                  </Form.Item>

                  <Form.Item
                    name="start_time_cd"
                    label="시작"
                    style={{ marginLeft: 30 }}
                  >
                    <Select
                      onChange={onChangeStartTime}
                      style={{ marginLeft: 5 }}
                    >
                      <Option value="">선택</Option>
                      {hourConfig.map((item, index) => {
                        return (
                          <Option value={item.seq} key={index}>
                            {item.value}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="end_time_cd"
                    label="종료"
                    style={{ marginLeft: 30 }}
                  >
                    <Select
                      onChange={onChangeEndTime}
                      style={{ marginLeft: 5 }}
                    >
                      <Option value="">선택</Option>
                      {endHourConfig.map((item, index) => {
                        return (
                          <Option value={item.seq} key={index}>
                            {item.value}
                          </Option>
                        );
                        //}
                      })}
                    </Select>
                  </Form.Item>
                  <Form.Item name="start_time" style={{ display: "none" }}>
                    <Input type="hidden" />
                  </Form.Item>
                  <Form.Item name="end_time" style={{ display: "none" }}>
                    <Input type="hidden" />
                  </Form.Item>
                  <Form.Item {...tailLayout} style={{ marginLeft: 35 }}>
                    <Button type="primary" htmlType="submit">
                      수업일정 등록
                    </Button>
                  </Form.Item>
                  <Form.Item
                    {...tailLayout}
                    style={{ marginLeft: 35, marginTop: 5 }}
                  >
                    <Button
                      type="danger"
                      htmlType="button"
                      style={{ marginTop: 60 }}
                      onClick={onCopyButton}                      
                    >
                      수업일정 복사
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
            <div className="table-body">
              <Table dataSource={dataSource} columns={columns} rowKey="seq" />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default ReservationOnPopup;
